export const GET_POLICY_LIST = "GET_POLICY_LIST";
export const GET_POLICY_LIST_SUCCESS = "GET_POLICY_LIST_SUCCESS";
export const GET_POLICY_LIST_FAIL = "GET_POLICY_LIST_FAIL";

export const UPLOAD_POLICY_DOC = "UPLOAD_POLICY_DOC";
export const UPLOAD_POLICY_DOC_SUCCESS = "UPLOAD_POLICY_DOC_SUCCESS";
export const UPLOAD_POLICY_DOC_FAIL = "UPLOAD_POLICY_DOC_FAIL";

export const DELETE_POLICY = "DELETE_POLICY";
export const DELETE_POLICY_SUCCESS = "DELETE_POLICY_SUCCESS";
export const DELETE_POLICY_FAIL = "DELETE_POLICY_FAIL";
